exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "header {\n  top: 0;\n  position: fixed;\n  width: 100%;\n  z-index: 200;\n}\n", "", {"version":3,"sources":["/app/client/src/components/Header/header.css"],"names":[],"mappings":"AAAA;EACE,OAAM;EACN,gBAAe;EACf,YAAW;EACX,aAAY;CACd","file":"header.css","sourcesContent":["header {\n  top: 0;\n  position: fixed;\n  width: 100%;\n  z-index: 200;\n}\n"],"sourceRoot":""}]);

// exports
